<template>
  <component :is="scannerComponent" />
</template>

<script>
import { mapGetters } from "vuex";
import Scanner from "./Scanner.vue";
import QRCodeReader from "./QRCodeReader.vue";

export default {
  name: "ScannerHost",
  components: { Scanner, QRCodeReader },
  computed: {
    ...mapGetters(["isQrScanner"]),
    scannerComponent() {
      return this.isQrScanner ? "QRCodeReader" : "Scanner";
    },
  },
};
</script>
